import { QueryClient as r, QueryCache as o } from "@tanstack/react-query";
import { createAPIClient as t } from "../api/create-api-client.js";
const a = t(), c = new r({
  defaultOptions: {
    queries: {
      staleTime: 1e3 * 60
    }
  },
  queryCache: new o({
    onError: (e) => console.error("Notification:", e)
  })
});
export {
  a as apiClient,
  c as queryClient
};
